export async function getSavings(
	listPrice: number,
	isRealtyApplied: boolean,
	countyId: number
): Promise<any> {
	const stringListPrice = listPrice.toString()
	const normalizedListPrice = parseFloat(stringListPrice.replace(/,/g, ''));
	const downPaymentPercent = 0.2;
	const downPaymentDollars = normalizedListPrice * downPaymentPercent;
	const loanAmountDollars = normalizedListPrice - (downPaymentDollars);
	
	const url = "/quoteApi/v1/request-savings/";

	const data = {
		"CountyId": countyId,
		"DownPayment": downPaymentDollars,
		"LoanAmount": loanAmountDollars,
		"LoanProgram": "Conventional",
		"LoanPurpose": "Purchase",
		"LoanTerm": 30,
		"LoanType": "Fixed",
		"NeedRealtyTeam": isRealtyApplied,
		"PropertyType": "Single Family Residence",
		"PropertyUse": "Primary Residence",
		"PropertyValue": normalizedListPrice,
		"PurchasePrice": normalizedListPrice,
		"HomeownersInsuranceEscrow": 0,
		"PropertyTax": 0,
		"ExistingLoanBalance": 0,
		"OriginalLoanAmount": 0,
		"FirstTimeHomeBuyer": false,
		"PurchasedWithinLastYear": false
	};

	try {
		const response = await fetch(url, {method:"POST", 
		headers: {
			'content-type': 'application/json;charset=UTF-8',
		}, body: JSON.stringify(data)});
		const savings = await response.json();

		return [savings];
	}
	catch (error) {
		console.error('Error: Cannot retrieve savings data from the QuoteService API. ', error);
		return false;
	}
}